import { Provider } from './Provider';
import { Element } from './Element';
Provider.displayName = 'ScrollView.Provider';
Element.displayName = 'ScrollView.Element';
export var ScrollView = {
    Provider: Provider,
    Element: Element,
};
export * from './types';
export * from './utils/useScrollView';
export * from './utils/useScrollViewAnimationTrigger';
//# sourceMappingURL=index.js.map